import * as React from "react";
import { Paragraph } from "scuid-x";
import { DocDescs } from "../constants/DocDescs";
import { DocType } from "../constants/DocType";

export interface DocDescProps {
  docType: DocType;
}

export const DocDesc: React.SFC<DocDescProps> = (props) => {
  const docDesc = DocDescs.getDocDesc(props.docType);
  if (!docDesc) {
    return (null);
  }

  return (
    <Paragraph>
      {docDesc.desc}
    </Paragraph>
  );
};



// WEBPACK FOOTER //
// ./src/components/DocDesc.tsx